/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/familyIdentityTheftMonitoringSubscriptionAuthenticationMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a FamilyIdentityTheftMonitoringSubscriptionAuthentication. */
export class FamilyIdentityTheftMonitoringSubscriptionAuthentication {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a FamilyIdentityTheftMonitoringSubscriptionAuthentication.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls the EnrollmentAndAuthenticationAPIs to request ID verification questions to verify the
   * requested member(csid) identity.
   * @summary Gets the ID verification questions for the requested member(csid) authentication.
   * @param csid
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationResponse>
   */
  getIDVerification(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationOptionalParams): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  getIDVerification(csid: string, callback: coreHttp.ServiceCallback<Models.GetIdVerificationApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  getIDVerification(csid: string, options: Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationOptionalParams, callback: coreHttp.ServiceCallback<Models.GetIdVerificationApiResponse>): void;
  getIDVerification(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationOptionalParams | coreHttp.ServiceCallback<Models.GetIdVerificationApiResponse>, callback?: coreHttp.ServiceCallback<Models.GetIdVerificationApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      getIDVerificationOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationResponse>;
  }

  /**
   * Calls the EnrollmentAndAuthenticationAPIs to submit ID verification answers to verify the
   * requested member(csid) identity.
   * @summary Submits the ID verification answers for the requested member(csid) authentication.
   * @param csid
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationResponse>
   */
  submitIDVerification(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationOptionalParams): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  submitIDVerification(csid: string, callback: coreHttp.ServiceCallback<Models.SubmitIdVerificationDataApiResponse>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  submitIDVerification(csid: string, options: Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationOptionalParams, callback: coreHttp.ServiceCallback<Models.SubmitIdVerificationDataApiResponse>): void;
  submitIDVerification(csid: string, options?: Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationOptionalParams | coreHttp.ServiceCallback<Models.SubmitIdVerificationDataApiResponse>, callback?: coreHttp.ServiceCallback<Models.SubmitIdVerificationDataApiResponse>): Promise<Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      submitIDVerificationOperationSpec,
      callback) as Promise<Models.FamilyIdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getIDVerificationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/SubscriptionAuthentication/id/verification/get",
  urlParameters: [
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.GetIdVerificationApiRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.GetIdVerificationApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const submitIDVerificationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/SubscriptionAuthentication/id/verification/submit",
  urlParameters: [
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.SubmitIdVerificationDataApiRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.SubmitIdVerificationDataApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
